module.exports = window["wc"]["blocksCheckout"];